<template>
  <div>
    <the-nav-bar :title="$t('mine.faq')" />
    <div class="field-wrapper">
      <div class="video-div-title" v-if="navLang === 'zh-cn'" >
        <span>新手视频教程</span>
        <span class="video-title-tip" @click="showVideoPlayProblemTipDialog">播放遇到问题？</span>
      </div>
      <div class="video-grid field" v-if="navLang === 'zh-cn'" >
        <div 
          class="video-item" 
          v-for="(video, index) in videoTutorials" 
          :key="`video-${index}`"
          @click="playVideo(video)"
        >
          <div class="video-content">
            <div class="video-cover">
              <img :src="video.thumbnail" class="video-cover-img" :alt="video.title" />
              <img class="video-play-icon" src="@/images/video-play-icon.png" />
              <span class="video-duration">{{ video.duration }}</span>
            </div>
          </div>
          <div class="video-title">{{ video.title }}</div>
        </div>
      </div>

      <div class="field" v-for="(list, i) in routerLinkList" :key="i">
        <div
          class="field-item row-justify-center"
          v-for="(item, j) in list"
          :key="`${i}-${j}`"
          @click="linkTo(item)"
        >
          <!-- <svg class="field-item-icon">
            <use xlink:href="#icon-global-dot" />
          </svg> -->
          <div class="field-item-text" v-html="item.text"></div>

          <md-icon name="arrow-right" color="#e8e8f2"></md-icon>
        </div>
      </div>
    </div>

    <md-popup v-model="isShowPopup" position="bottom">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="popupTitle"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="scroll-view">
        <div
          class="scroll-item row-center"
          v-html="this.detail"
        >
        </div>
      </md-scroll-view>
    </md-popup>

    <md-dialog
      :title="this.$t('common.videoPlayProblemTipTitle')"
      :closable="false"
      :mask-closable="true"
      v-model="videoPlayProblemTipDialog.open"
      :btns="videoPlayProblemTipDialog.btns"
    >
    播放视频遇到问题，切换更稳定的网络试试，
    或者<span style="color:#1b6fdc;">请到机器人留言</span>：视频教程。
    <br/>例如：买币视频教程，卖币视频教程等。
    <br/><span style="color:#1b6fdc;">机器人将根据关键词自动回复。</span>
    <br/>类似的，您可以向机器人留言： 图文教程。
    <p style="margin-top: 5px;"></p>
    </md-dialog>

    <!-- 视频播放弹窗 -->
    <md-popup 
      v-model="videoPopup.visible" 
      position="center"
      :mask-closable="true"
    >
      <div v-if="videoPopup.currentVideo" class="video-popup-container">
        <div class="video-popup-header">
          <span class="video-popup-title">{{ videoPopup.currentVideo.title }}</span>
          <md-icon 
            name="close" 
            size="lg" 
            color="#666"
            @click.native="closeVideoPopup"
            class="video-popup-close"
          />
        </div>
        <div class="video-popup-content">
          <video 
            v-if="videoPopup.visible"
            :src="videoPopup.currentVideo.url"
            controls 
            autoplay 
            playsinline 
            webkit-playsinline
            class="video-player"
            @loadedmetadata="handleVideoMetadata"
          ></video>
        </div>
      </div>
    </md-popup>

  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import { mapState } from 'vuex';
import { Icon, Popup, PopupTitleBar, ScrollView, Dialog} from 'mand-mobile';
// import VConsole from 'vconsole';
// new VConsole(); //调试 测试用
export default {
  components: {
    TheNavBar,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      isShowPopup: false,
      popupTitle: '',
      detail:'',
      videoTutorials: [
        {
          title: '如何购买数字币',
          thumbnail: require('@/images/video-cover-buy.png'),
          duration: '2:55',
          url: 'https://uploads.mixin.one/mixin/attachments/1759176400-1f6b06b5e08cdddf9cbeec113e16685f23b33e34acf7b153d953c16991599616',
        },
        {
          title: '如何出售数字币',
          thumbnail:  require('@/images/video-cover-sell.png'),
          duration: '3:03',
          url: 'https://uploads.mixin.one/mixin/attachments/1759176202-1d70c200f8e681cb5fd1d4d7cae5209b65e6aade939db0b3b0313606c07a88f0',
        },

        // Add more video tutorials here...
      ],
      videoPlayProblemTipDialog:{
        open:false,
        btns:[
          {
            text: this.$t('common.confirm'),
            warning: false,
            handler: this.walletBlanceTipDialogClose,
          },
        ],
      },
      videoPopup: {
        visible: false,
        currentVideo: null,
        aspectRatio: 56.25, // 默认16:9横屏比例，会根据实际视频动态调整
      },
    };
  },
  computed: {
    ...mapState({
      isLogin: state => state.isLogin,
      userInfo: state => state.userInfo,
      navLang: state => state.navLang,
      routerLinkList() {
        return [
          [
            {
              text: this.$t('global.faqs[0].q'),
              detail: this.$t('global.faqs[0].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[1].q'),
              detail: this.$t('global.faqs[1].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[2].q'),
              detail: this.$t('global.faqs[2].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[3].q'),
              detail: this.$t('global.faqs[3].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[4].q'),
              detail: this.$t('global.faqs[4].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[5].q'),
              detail: this.$t('global.faqs[5].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[6].q'),
              detail: this.$t('global.faqs[6].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[7].q'),
              detail: this.$t('global.faqs[7].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[8].q'),
              detail: this.$t('global.faqs[8].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[9].q'),
              detail: this.$t('global.faqs[9].a'),
              handler: this.showPopup,
            }, 
            {
              text: this.$t('global.faqs[10].q'),
              detail: this.$t('global.faqs[10].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[11].q'),
              detail: this.$t('global.faqs[11].a'),
              handler: this.showPopup,
            },  
            {
              text: this.$t('global.faqs[12].q'),
              detail: this.$t('global.faqs[12].a'),
              handler: this.showPopup,
            },  
            {
              text: this.$t('global.faqs[13].q'),
              detail: this.$t('global.faqs[13].a'),
              handler: this.showPopup,
            },
            {
              text: this.$t('global.faqs[14].q'),
              detail: this.$t('global.faqs[14].a'),
              handler: this.showPopup,
            },  
            {
              text: this.$t('global.faqs[15].q'),
              detail: this.$t('global.faqs[15].a'),
              handler: this.showPopup,
            },                
          ],
          [
            {
              text: this.$t('global.faqsMore'),
              hrefObj: {
                'zh-cn': 'https://help.tigaex.com/zh',
                en: 'https://help.tigaex.com/en',
              },
            },
          ],
        ];
      },
    }),
  },
  created() {

  },
  methods: {
    showPopup() {
      this.isShowPopup = true;
    },
    hidePopup() {
      this.isShowPopup = false;
    },
    linkTo(item) {
      if (typeof item.handler === 'function') {
        this.popupTitle = item.text;
        this.detail = item.detail;
        item.handler.call(item);
      }
      if (item.hrefObj) {
        return window.open(
          item.hrefObj[this.navLang],
          '_blank',
          'noopeener',
        );
      }
    },
    playVideo(video) {
      this.videoPopup.currentVideo = video;
      this.videoPopup.visible = true;
      // 重置为默认比例
      this.videoPopup.aspectRatio = 56.25;
      
      // 等待DOM更新后设置视频显示方式
      this.$nextTick(() => {
        const videoElement = document.querySelector('.video-player');
        if (videoElement) {
          videoElement.style.objectFit = 'contain';
        }
      });
    },
    closeVideoPopup() {      
      this.videoPopup.visible = false;
      // 延迟清空，避免关闭动画时出现空白
      setTimeout(() => {
        this.videoPopup.currentVideo = null;
      }, 300);
    },
    showVideoPlayProblemTipDialog() {
      this.videoPlayProblemTipDialog.open = true;
    },
    hideVideoPlayProblemTipDialog() {
      this.videoPlayProblemTipDialog.open = false;
    },
    handleVideoMetadata(event) {
      const video = event.target;
      const width = video.videoWidth;
      const height = video.videoHeight;
      
      // 计算宽高比百分比 (height/width * 100)
      if (width && height) {
        const aspectRatio = (height / width) * 100;
        this.videoPopup.aspectRatio = aspectRatio;
        
        // 动态设置容器的padding-bottom
        this.$nextTick(() => {
          const contentElement = document.querySelector('.video-popup-content');
          if (contentElement) {
            contentElement.style.paddingBottom = `${aspectRatio}%`;
          }
        });
      }
    },
  },
};
</script>

<style lang="stylus" scoped>

.field-wrapper {
  color: #23222e;
  /* padding-top: 3vw; */
  border-top: 2.13vw solid #F8FBFC;

  .field + .field {
    border-top: 2.13vw solid #F8FBFC;
  }

  .field-item {
    flex-row-justify();
    height: 16.18vw;
    padding: 0 4vw;

    .field-item-icon {
      icon-size(6.4vw);
      padding-bottom: 2vw
    }

    .field-item-text {
      flex: 1;
      font-size: 3.73vw;
      border-bottom: 1px solid #e8e8f2
      padding-bottom: 1.18vw
    }

    .field-item-tag {
      icon-size(6.4vw);
      margin-right: 4.8vw;
    }
  }
}

.video-div-title {
  font-size: 4vw;
  font-weight: bold;
  padding: 4vw 4vw 2vw;
  color: #333;
  .video-title-tip {
    font-size: 2.67vw;
    color: #999;
  }
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 3vw;
  padding: 0 4vw 4vw;
}

.video-item {
  cursor: pointer;
}

.video-content {
  position: relative;
  width: 100%;
  margin-bottom: 2vw;
}

.video-cover {
  position: relative;
  border-radius: 2vw;
  overflow: hidden;
  padding-bottom: 56.25%; /* 16:9 ratio */
}

.video-cover-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #f5f5f5;
  transition: all 0.3s;
}

.video-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10vw;
  height: 10vw;
  z-index: 2;
}

.video-duration {
  position: absolute;
  bottom: 1.5vw;
  right: 1.5vw;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 2.5vw;
  padding: 0.5vw 1vw;
  border-radius: 1vw;
  z-index: 2;
}

.video-title {
  font-size: 3.2vw;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 9vw;
  color: #333;
}

.thumbnail-container {
  display: none; /* 移除旧的缩略图容器样式 */
}

.arrow-right
  fill: #e8e8f2

.title-bar {
border-bottom: 0.27vw solid #eaf1f3;
}

.scroll-view {
  background: #fff;
  padding-bottom: 10vw;
  height: auto;
  min-height: 60vw;
  max-height: 80vw;
  overflow-y: auto;
}

.scroll-item {
  display block;
  padding: 3.8vw 5.8vw 3.8vw 5.8vw;
  font-size: 4.27vw;
  height: 15.8vw;
  padding-bottom: 10vw;

  &.active {
    color: color-primary;
  }
}

.video-popup-container {
  width: 94vw;
  max-width: 580px;
  background-color: #fff;
  border-radius: 1.5vw;
  padding: 2vw 2vw 2.5vw;
  box-shadow: 0 0 10vw rgba(0, 0, 0, 0.3);
}

.video-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2vw;
  margin-bottom: 2vw;
  border-bottom: 1px solid #e8e8f2;
  min-height: 9vw;
}

.video-popup-title {
  font-size: 3.8vw;
  font-weight: bold;
  flex: 1;
  padding-right: 3vw;
  line-height: 1.3;
}

.video-popup-close {
  cursor: pointer;
  flex-shrink: 0;
  padding: 2vw;
  margin: -2vw;
  min-width: 9vw;
  min-height: 9vw;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-popup-content {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 ratio */
  background-color: #000;
  border-radius: 1vw;
  overflow: hidden;
}

.video-player {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  object-fit: contain;
}
</style>